import { Card, CardContent, Typography } from "@mui/material";
import { OrderDetails } from "../types/types";

export const CustomerDetails = ({ orderDetails }: { orderDetails: OrderDetails }) => (
  <Card sx={{ mb: 3, bgcolor: "background.paper" }}>
    <CardContent>
      <Typography variant="h6" gutterBottom>
        Customer Details
      </Typography>
      <Typography variant="body1">
        <strong>Name:</strong> {orderDetails.customer_name || "N/A"}
      </Typography>
      <Typography variant="body1">
        <strong>Email:</strong> {orderDetails.customer_email || "N/A"}
      </Typography>
      <Typography variant="body1">
        <strong>Dispensary:</strong> {orderDetails.customer_dispensary_name || "N/A"}
      </Typography>
      <Typography variant="body1">
        <strong>Shipping Address:</strong> {orderDetails.shipping_address || "N/A"}
      </Typography>
    </CardContent>
  </Card>
);